/*
 * SANBY 共通ユーティリティ
 * 通貨フォーマット、ブレークポイント判定等を提供する。
 * カート関連（旧getCart/setCart/cartCount、localStorageモック）はcart-api.js（Ajax Cart API）に置換済み。
 */
window.SANBY = window.SANBY || {};

(function (SANBY) {
  // CSS側（spec/仕様書.md §5）と同じ2段階のブレークポイント。値が食い違うと
  // ヒーローカルーセルの余白計算やドロワーの自動クローズがCSSの見た目とズレるので、
  // CSSのメディアクエリを変更したら必ずこちらも合わせる。
  const BREAKPOINT_TABLET = 940; // サイドバー消失の境界
  const BREAKPOINT_MOBILE = 748; // ヘッダー・カテゴリナビのモバイル切替の境界

  function formatCurrency(amount) {
    return "¥" + Math.round(amount).toLocaleString("ja-JP");
  }

  // サイドバーが表示される幅かどうか（940px〜）
  function hasSidebar() {
    return window.innerWidth >= BREAKPOINT_TABLET;
  }

  // ヘッダーがモバイル表示（ハンバーガー＋アイコンのみ）かどうか（〜748px）
  function isMobile() {
    return window.innerWidth < BREAKPOINT_MOBILE;
  }

  // resize を監視し、モバイル/デスクトップの境界（748px）をまたいだ時だけ callback を呼ぶ
  function onBreakpointChange(callback) {
    let current = isMobile();
    callback(current);
    window.addEventListener("resize", () => {
      const next = isMobile();
      if (next !== current) {
        current = next;
        callback(current);
      }
    });
  }

  // Q&Aリスト（.qa-list、components.css）の開閉トグル共通処理。
  // faq/first-time/category-lpで別々に実装されていたQ&A一覧を.qa-listに統合した際、
  // アコーディオン開閉のJSロジックも共通化した。.qa-list.is-static（常時表示）な
  // ページはこの関数を呼ばなくてよい（.qa-qがbuttonではなくdivのため対象にならない）。
  function initQaAccordion(root) {
    (root || document).querySelectorAll("[data-qa-item]").forEach((item) => {
      const q = item.querySelector(".qa-q");
      const a = item.querySelector(".qa-a");
      if (!q || !a || q.tagName !== "BUTTON") return;
      q.addEventListener("click", () => {
        const willOpen = a.hidden;
        a.hidden = !willOpen;
        q.setAttribute("aria-expanded", String(willOpen));
        item.classList.toggle("is-open", willOpen);
        const toggle = item.querySelector(".qa-toggle");
        if (toggle) toggle.textContent = willOpen ? "－" : "＋";
      });
    });
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  SANBY.utils = {
    BREAKPOINT_TABLET,
    BREAKPOINT_MOBILE,
    formatCurrency,
    hasSidebar,
    isMobile,
    onBreakpointChange,
    initQaAccordion,
    escapeHtml,
  };
})(window.SANBY);
